import { format } from 'date-fns';
import { parseLocalDate } from '../lib/dateUtils';

// Renders prior_auth_history rows as a compact table. Used by the Prior Auth
// tracker (per record, single type) and the client profile (all types).
const fmt = (d) => { try { return d ? format(parseLocalDate(d), 'MMM d, yyyy') : '—'; } catch { return d || '—'; } };
const hrs = (v) => (v != null && v !== '' ? String(v) : '—');

export default function AuthHistoryTable({ rows, showType = false }) {
  if (!rows) {
    return <div style={{ padding: '20px 0', textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>Loading history…</div>;
  }
  if (!rows.length) {
    return <div style={{ padding: '20px 0', textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>No authorization history yet.</div>;
  }

  const th = { textAlign: 'left', padding: '7px 10px', fontSize: 11, fontWeight: 600, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' };
  const td = { padding: '8px 10px', fontSize: 12, color: 'var(--text2)', borderTop: '0.5px solid var(--border)' };

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: 'var(--bg2)' }}>
            {showType && <th style={th}>Type</th>}
            <th style={th}>Number</th>
            <th style={th}>Submitted</th>
            <th style={th}>Starts</th>
            <th style={th}>Expiry</th>
            <th style={{ ...th, textAlign: 'center' }}>Skilled</th>
            <th style={{ ...th, textAlign: 'center' }}>PSS</th>
            <th style={th}>Updated by</th>
            <th style={{ ...th, textAlign: 'right' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const active = r.status === 'active';
            return (
              <tr key={r.id} style={{ color: active ? 'var(--text2)' : 'var(--text3)' }}>
                {showType && <td style={{ ...td, fontWeight: 500 }}>{r.auth_type}</td>}
                <td style={{ ...td, fontFamily: 'monospace', fontSize: 11 }}>{r.auth_number || '—'}</td>
                <td style={td}>{fmt(r.submitted_date)}</td>
                <td style={td}>{fmt(r.effective_date)}</td>
                <td style={td}>{fmt(r.expiry_date)}</td>
                <td style={{ ...td, textAlign: 'center' }}>{hrs(r.skilled_hours_week)}</td>
                <td style={{ ...td, textAlign: 'center' }}>{hrs(r.pss_hours_week)}</td>
                <td style={td}>{r.created_by_name || '—'}</td>
                <td style={{ ...td, textAlign: 'right' }}>
                  <span style={{
                    fontSize: 10, fontWeight: 500, padding: '2px 8px', borderRadius: 10, whiteSpace: 'nowrap',
                    background: active ? 'var(--success-bg)' : 'var(--bg2)',
                    color: active ? 'var(--success)' : 'var(--text3)',
                  }}>{active ? 'Active' : 'Superseded'}</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
